import * as $ from 'jquery';

export function initializeApplePay() {
    if (window.ApplePaySession) {
        let applePayPaymentMethod = $('[data-apple-pay-payment-method]');
        if (applePayPaymentMethod.length && applePayPaymentMethod.data('apple-pay-merchant-id')) {
            window.ApplePaySession
                .canMakePaymentsWithActiveCard(applePayPaymentMethod.data('apple-pay-merchant-id'))
                .then(result => {
                    if (result) {
                        applePayPaymentMethod.show();
                    }
                })
        }
        let applePayButton = $('button.apple-pay-button');
        if (applePayButton.length) {
            let total = {
                "label": applePayButton.data('label'),
                "amount": applePayButton.data('total-amount') / 100,
                "type": "final"
            };

            ApplePaySession
                .canMakePaymentsWithActiveCard(applePayButton.data('merchant-id'))
                .then(function (canMakePayments) {
                    if (canMakePayments) {
                        applePayButton.css('display', 'inline-block');
                    }
                });

            applePayButton.on('click', function () {
                let request = {
                        countryCode: 'CZ',
                        currencyCode: 'CZK',
                        supportedNetworks: ['visa', 'masterCard'],
                        merchantCapabilities: ['supports3DS'],
                        total: total,
                    },
                    paySession = new ApplePaySession(9, request);

                paySession.onvalidatemerchant = function (event) {
                    $.ajax({
                        url: applePayButton.data('merchant-validate-url'),
                        method: "POST",
                        contentType: "application/json; charset=utf-8",
                        data: JSON.stringify({ValidationUrl: event.validationURL})
                    }).then(function (merchantSession) {
                        paySession.completeMerchantValidation(merchantSession);
                    }, function () {
                        paySession.abort();
                    });
                };

                paySession.onpaymentmethodselected = function () {
                    paySession.completePaymentMethodSelection({newTotal: total});
                };

                paySession.onpaymentauthorized = function (event) {
                    $.ajax({
                        url: applePayButton.data('pay-url'),
                        method: "POST",
                        contentType: "application/json; charset=utf-8",
                        data: JSON.stringify(event.payment.token)
                    }).then(function (result) {
                        if (result.success) {
                            paySession.completePayment(ApplePaySession.STATUS_SUCCESS);
                            window.location = applePayButton.data('success-redirect-url');
                        } else {
                            paySession.completePayment(ApplePaySession.STATUS_FAILURE);
                        }

                    }, function () {
                        paySession.completePayment(ApplePaySession.STATUS_FAILURE);
                    });
                };

                paySession.begin();
            });
        }
    }
}
